import React from "react";
import {store} from "../../../../../Store/index.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";
import {Text, OrbitControls} from "@react-three/drei";
import {minuteInMS} from "web-vcore";

export const FSStatsUI = observer_mgl_r3((props: {mainTexWToHRatio: number})=>{
	const {mainTexWToHRatio} = props;
	const vrState = store.main.tools.vr;
	const vrSettings = store.main.settings.vr;

	// Calculate positioning for stats-panel (to right of main frame)
	const mainFrameRightEdge = mainTexWToHRatio / 2;
	const distanceFromMainFrame = .02;
	const panelWidth = .5;
	const panelHeight = 1;
	const xOffset = mainFrameRightEdge + distanceFromMainFrame + (panelWidth / 2);

	/*const statsText = `
		Frames: ${vrState.imageFramesDisplayed_duringRemoteSession}
		Time: ${(vrState.timeCredit_duringRemoteSession / minuteInMS).FloorTo(1)}m
	`.AsMultiline(0);*/
	const statsText = [
		`${vrState.imageFramesDisplayed_duringRemoteSession}`,
		`(${(vrState.timeCredit_duringRemoteSession / minuteInMS).FloorTo(1)}m),`,
		`${vrState.memoryPalacePrompts_duringRemoteSession}`,
	].join(" ");

	return (
		<mesh position={[xOffset, 0, 0]}>
			{/*<planeGeometry args={[panelWidth, panelHeight]}/>
			<meshBasicMaterial color="gray" transparent={true} opacity={.05}/>*/}
			<React.Suspense fallback={null}>
				<Text position={[-panelWidth / 2, .5, 0]} anchorX="left" anchorY="top"
					fontSize={0.03} color="white" fillOpacity={vrSettings.stats_opacity}
				>
					{statsText}
				</Text>
		  	</React.Suspense>
		</mesh>
	);
});